export function productLabel(name) {
  const raw = String(name || '').trim();
  if (!raw) return 'Health Insurance';
  const titled = raw.toLowerCase().replace(/(^|[^a-z0-9])([a-z])/g, (match, prefix, letter) => (
    `${prefix}${letter.toUpperCase()}`
  ));
  return titled.replace(/^New\s+/, '');
}

export function principalMember(policy) {
  const members = Array.isArray(policy?.members) ? policy.members : [];
  return members.find((member) => String(member.relationship || '').toLowerCase() === 'principal')
    || members[0]
    || null;
}

export function formatKes(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '—';
  const cents = Math.round(amount * 100) % 100;
  return amount.toLocaleString('en-KE', {
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

export function benefitTitle(benefit) {
  const raw = benefit && typeof benefit === 'object'
    ? (benefit.benefitName || benefit.benefit)
    : benefit;
  if (raw === null || raw === undefined || raw === '') return 'Benefit';
  const text = String(raw).trim();
  if (/^\d+$/.test(text)) {
    return text === '1' ? 'Inpatient' : `Benefit ${text}`;
  }
  return text.toLowerCase().replace(/(^|[^a-z0-9])([a-z])/g, (match, prefix, letter) => (
    `${prefix}${letter.toUpperCase()}`
  ));
}

function benefitSortKey(benefit) {
  const title = benefitTitle(benefit).toLowerCase();
  if (title === 'inpatient' || Number(benefit?.benefit) === 1) return `0${title}`;
  return `1${title}`;
}

export function benefitsForMember(policy, memberNo) {
  return (Array.isArray(policy?.benefits) ? policy.benefits : [])
    .filter((benefit) => benefit.memberNo === memberNo)
    .slice()
    .sort((left, right) => benefitSortKey(left).localeCompare(benefitSortKey(right)));
}

export function memberCountLabel(policy) {
  const count = Array.isArray(policy?.members) ? policy.members.length : 0;
  if (count === 0) return 'No members listed';
  return `${count} ${count === 1 ? 'member' : 'members'}`;
}
